module.exports = __webpack_public_path__ + "img/SlideShow02.aab98dac.jpg";